// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".genetic-type-tag-module__geneticTypeTag__165Wk,.genetic-type-tag-module__germlineTag__Rl2l6,.genetic-type-tag-module__somaticTag__yQxEL{font-weight:500 !important;font-family:'Gotham Book';font-size:12px;line-height:18px;display:inline-flex;padding:0 var(--radius-8, 0.5rem);justify-content:center;align-items:center;gap:var(--radius-8, 8px);border-radius:56px}.genetic-type-tag-module__germlineTag__Rl2l6{color:#0968c3;border:var(--radius-2, 2px) solid var(--Color-11, #0968c3);background:#f0f5ff}.genetic-type-tag-module__somaticTag__yQxEL{color:#ffffff;background:#0968c3}\n", ""]);
// Exports
exports.locals = {
	"geneticTypeTag": "genetic-type-tag-module__geneticTypeTag__165Wk",
	"germlineTag": "genetic-type-tag-module__germlineTag__Rl2l6",
	"somaticTag": "genetic-type-tag-module__somaticTag__yQxEL"
};
module.exports = exports;
